const mediaItems = [
  { title: '暗夜追踪者 - 终极预告片', duration: '02:45', views: '125万', imgUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20trailer%20scene%20with%20dramatic%20urban%20night%20lighting%2C%20film%20noir%20aesthetic%2C%20intense%20atmosphere%2C%20deep%20contrast%2C%20professional%20cinematography%2C%20no%20text%20no%20people&width=600&height=340&seq=media-01&orientation=landscape' },
  { title: '盛夏光年 - 青春篇章', duration: '01:58', views: '89万', imgUrl: 'https://readdy.ai/api/search-image?query=Warm%20summer%20cinematic%20scene%20with%20soft%20golden%20sunlight%2C%20youth%20film%20aesthetic%2C%20dreamy%20atmosphere%2C%20nostalgic%20tones%2C%20gentle%20lighting%2C%20no%20text%20no%20people&width=600&height=340&seq=media-02&orientation=landscape' },
  { title: '迷雾深渊 - 导演访谈特辑', duration: '15:20', views: '63万', imgUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20sci%20fi%20cinematic%20scene%20with%20fog%20and%20dramatic%20blue%20and%20amber%20lighting%2C%20atmospheric%20composition%2C%20film%20aesthetic%2C%20deep%20shadows%2C%20no%20text%20no%20people&width=600&height=340&seq=media-03&orientation=landscape' },
  { title: '长安十二时辰 - 幕后花絮', duration: '08:12', views: '97万', imgUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20cinematic%20scene%20with%20warm%20lantern%20lighting%2C%20historical%20drama%20aesthetic%2C%20rich%20amber%20and%20red%20tones%2C%20atmospheric%20period%20setting%2C%20no%20text%20no%20people&width=600&height=340&seq=media-04&orientation=landscape' },
  { title: '深海迷城 - 视觉特效解析', duration: '06:35', views: '71万', imgUrl: 'https://readdy.ai/api/search-image?query=Underwater%20cinematic%20scene%20with%20mysterious%20deep%20ocean%20lighting%2C%20fantasy%20adventure%20aesthetic%2C%20blue%20and%20teal%20tones%20with%20light%20rays%2C%20atmospheric%20underwater%20world%2C%20no%20text%20no%20people&width=600&height=340&seq=media-05&orientation=landscape' },
];

export default function SectionMedia() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center">
            <i className="ri-play-circle-line text-primary-600 text-lg"></i>
          </div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">精彩视频</h2>
        </div>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10 pl-11">热门影片预告与独家花絮</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className={`group relative rounded-xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer ${
                i === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden bg-background-200 ${i === 0 ? 'aspect-[16/9] lg:aspect-auto lg:h-full' : 'aspect-[16/9]'}`}>
                <img
                  src={item.imgUrl}
                  alt={`${item.title} - 密桃视频`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:scale-110 transition-all">
                    <i className="ri-play-fill text-foreground-900 text-xl md:text-2xl ml-0.5 group-hover:text-background-50 transition-colors"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-black/60 text-background-50 text-xs font-medium whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 line-clamp-2">{item.title}</h3>
                <div className="flex items-center gap-1 text-foreground-400">
                  <i className="ri-eye-line text-xs"></i>
                  <span className="text-xs">{item.views} 次播放</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}